import { ChangeDetectionStrategy, Component, computed, inject, input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ImageComponent } from '../../primitives/image/image.component';
import { SlideImage } from '@chemist2u/types-client/C2U/ParseObjects';

@Component({
    selector: 'app-slide',
    templateUrl: './slide.component.html',
    styleUrls: ['./slide.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ImageComponent]
})
export class SlideComponent implements OnInit {
  private sanitizer = inject(DomSanitizer);

  public slide = input.required<SlideImage>();
  public large = input<boolean>(false)

  public bgColor = computed<string>(() => this.slide().backgroundColor);
  public htmlContent = computed<string>(() => this.slide().htmlContent);
  public imageSrc = computed<string>(() => this.slide().image.url());
  public newTile = computed<boolean>(() => this.slide().new);

  public safeHTML: SafeHtml | undefined = undefined;
  
  ngOnInit() {
    this.safeHTML = this.sanitizer.bypassSecurityTrustHtml(this.htmlContent());
  }

}
